export const TABLE_HEAD = [
  'Node ID',
  'Hostname',
  'Status',
  'Last ping',
  'Config version',
];
